// Access Token is used for regular use on the platform
const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';

const getAccessToken = () => {
  // 1. Check sessionStorage first (from query params in iframes)
  const sessionToken = sessionStorage.getItem(ACCESS_TOKEN);
  if (sessionToken && sessionToken !== 'null') return sessionToken;

  // 2. Fallback to localStorage (user authentication)
  return localStorage.getItem(ACCESS_TOKEN);
};

const storeQueryParamToken = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const queryToken = queryParams.get(ACCESS_TOKEN);
  // DEV-800 We could validate that we are receiving a JWT with a proper structure

  if (queryToken && queryToken.length > 8) {
    sessionStorage.setItem(ACCESS_TOKEN, queryToken);
  }
};
const getRefreshToken = () => localStorage.getItem(REFRESH_TOKEN);

const storeAuthTokens = (accessToken, refreshToken) => {
  if (accessToken) {
    localStorage.setItem(ACCESS_TOKEN, accessToken);
  }
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN, refreshToken);
  }
};

const removeAuthTokens = () => {
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(REFRESH_TOKEN);
};

const decodeJwtPayload = token => {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = atob(base64);
    return JSON.parse(json);
  } catch {
    return null;
  }
};

export {
  ACCESS_TOKEN,
  decodeJwtPayload,
  getAccessToken,
  getRefreshToken,
  removeAuthTokens,
  storeAuthTokens,
  storeQueryParamToken,
};
